import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

interface ApiResponse<T = any> {
    result: number;
    value: T;
}

interface ApiError {
    ERROR?: string;
}

function extractErrorMessage(res: ApiResponse, defaultError: string): string {
    if (res?.value && Array.isArray(res.value) && res.value[0] && 'ERROR' in res.value[0]) {
        return (res.value[0] as ApiError).ERROR || defaultError;
    }
    return defaultError;
}

/**
 * Validates API response and throws error if invalid
 */
export function validateApiResponse<T = any>(defaultError: string = 'Error en la petición') {
    return (source: Observable<ApiResponse<T>>): Observable<T> => {
        return source.pipe(
            map((res: ApiResponse<T>) => {
                // Check for errors
                if (!res || res.result !== 0 || !res.value) {
                    const error = extractErrorMessage(res, defaultError);
                    throw new Error(error);
                }

                // Check for ERROR in first item
                if (Array.isArray(res.value) && res.value[0] && 'ERROR' in res.value[0]) {
                    const error = (res.value[0] as ApiError).ERROR || defaultError;
                    throw new Error(error);
                }

                return res.value;
            }),
            catchError((error) => {
                const message = error instanceof Error ? error.message : defaultError;
                return throwError(() => new Error(message));
            })
        );
    };
}
